import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage, throwSuccessMessage } from '../../../utils/Errors'
import { idleAndStandByMapper } from '../../../components/CoreSettings/utils/IdleAndStandByMapper'
import { ICoreSettings } from '../../../types/coreSettings'
import { convertEmptyValuesToNull } from '../../../components/CoreSettings/utils/convertEmptyValuesToNull'
import { hideRightBar } from '../../actions/rightBarActions'
import { fetchProductCoreSettings } from './fetchProductCoreSettings'
import { getUrlWithVersion } from '../../../api/api'

export const updateProductCoreSettings = createAsyncThunk<
    void,
    { guid: string; coreSettings: ICoreSettings },
    ThunkConfig<string>
>('coreSettingsSlice/updateProductCoreSettings', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
        dispatch,
    } = thunkAPI

    const { guid, coreSettings } = args
    try {
        const data = idleAndStandByMapper(coreSettings)
        convertEmptyValuesToNull(data)

        await api.put(
            getUrlWithVersion(`/products/${guid}/core_settings/general`),
            data
        )

        throwSuccessMessage('General settings successfully updated')
        dispatch(fetchProductCoreSettings({ guid }))
        dispatch(hideRightBar())
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('General settings update failed')
    }
})
